<template>
    <div class="button" :class="buttonInfo.class" @click="addToCart">
        {{buttonInfo.text}}
    </div>
</template>

<script>
export default {
    name : "AddToCartButton",
    props : {
        productId : {
            type : Number,
            required : true,
        },
        variantId : {
            type : Number,
            required : true,
        },
        availableQuantity : {
            type : Number,
            required : true,
        },
        quantity : {
            type : Number,
            required : true,
        },
    },
    computed : {
        inCart () {
            return this.$store.state[this.$STORE_CONSTANTS.CART].items.find(i => i.variantId === this.variantId);
        },
        buttonInfo () {
            if(this.inCart) {
                return {
                    text : 'Remove From Cart',
                    class : 'is-light',
                }
            }
            return {
                text : !this.availableQuantity && this.allowBackorders ? 'Back order' : 'Add To Cart',
                class : 'is-warning',
            };
        },
        allowBackorders () {
            return this.$getSessionContext().allowBackorders;
        },
    },
    methods : {
        addToCart () {
            if(this.inCart) {
                this.$store.commit(this.$STORE_CONSTANTS.CART.REMOVE_ITEM, this.variantId);
                this.$emit('removed');
                return;
            }
            this.$store.commit(this.$STORE_CONSTANTS.CART.ADD_ITEM, {
                productId : this.productId,
                variantId : this.variantId,
                quantity : this.quantity,
            });
            this.$emit('added');
        },
    },
}
</script>

<style scoped>

</style>
